import EndpointsBase  from "../EndpointsBase";
import OperatorEndpoints from "../operator/OperatorEndpoints";
import { IRxAssistantOperator } from "./IRxAssistantOperator";

class RxEndpoints extends EndpointsBase {

    pollForOrder = (operatorID: number, workstationID: number) => {
        return this._sendRequest({
            method: "sortbox/getcurrentrxorder",
            headers: this._getAuthHeader(),
            data: {operatorID, workstationID},
            run: this.server.getData,
        });
    }

    registerTransportCartForOrder = (operatorID: number,
        rxOrderSkuID :number,
        inputValue: string,
        isSingle: boolean) => {
        return this._sendRequest({
            method: "order/transportCart",
            headers: this._getAuthHeader(),
            data: {operatorID,
                rxOrderSkuID,
                inputValue,
                isSingle},
            run: this.server.postData
        });
    }

    fetchRxBox = () => {
        return this._sendRequest({
            method: "sortbox/getcurrentrxsortbox",
            headers: this._getAuthHeader(),
            data: {},
            run: this.server.getData
        });
    }

    pollForInstruction = (workstationID: number, errorCallback: (error: any) => void) => {
        return OperatorEndpoints.getWorkstationInstruction(workstationID)
          .then((result) => {
            return result;
          })
          .catch((error) => {
            errorCallback(error);
    
            const instruction = {
              desiredCartId: -1,
            };
            return instruction;
          });
    }

    fetchOrderComments = (orderNumber: number, errorCallback: (error: any) => void) => {
        return this._sendRequest({
            method: "order/comments",
            headers: this._getAuthHeader(),
            data: {orderNumber},
            run: this.server.getData
        }).catch((error) => {
            errorCallback(error);
        });
    }

    
    fetchWarningMessages = (rxOrderSku: number, errorCallback: (error: any) => void) => {
        return this._sendRequest({
            method: "order/warningMessages",
            headers: this._getAuthHeader(),
            data: {rxOrderSku},
            run: this.server.getData
        }).catch((error) => {
            errorCallback(error);
        });
    }

    getRxAssistantOperator = (errorCallback: (error: any) => void) => {
        return this._sendRequest({
            method: "operator/GetRXAssistantOperator",
            headers: this._getAuthHeader(),
            data: {},
            run: this.server.getData
        }).catch((error) => {
            errorCallback(error);
        });
    }

    setRxAssistantOperator = (rxAssistantOperator:IRxAssistantOperator, errorCallback: (error: any) => void) => {
        return this._sendRequest({
            method: "operator/SetRXAssistantOperator",
            headers: this._getAuthHeader(),
            data: {
                assistantOperatorId: rxAssistantOperator.assistingOperatorID,
                assistingMode: rxAssistantOperator.assistingMode},
            run: this.server.postData
        }).catch((error) => {
            errorCallback(error);
        });
    }

    clearRxAssistantOperator = (rxAssistantOperatorID:number, errorCallback: (error: any) => void) => {
        return this._sendRequest({
            method: "operator/ClearRXAssistantOperator/"+rxAssistantOperatorID.toString(),
            headers: this._getAuthHeader(),
            run: this.server.postData
        }).catch((error) => {
            errorCallback(error);
        });
    }

    registerCrate = (crateID: number) => {
        return this._sendRequest({
            method: "rx/registercrate",
            headers: this._getAuthHeader(),
            data: { crateID },
            run: this.server.postData
        });
    }

    printRXBoxID = (rxSortBoxID: number, workstationID: number) => {
        return this._sendRequest({
            method: "sortbox/printrxsortboxlabel",
            headers: this._getAuthHeader(),
            data: { rxSortBoxID, workstationID },
            run: this.server.postData
        });
    }
}

export default new RxEndpoints();